import React from 'react';
import { motion } from 'framer-motion';
import { GamerButton } from './ui/GamerButton';
export function ProductSection() {
  return <section id="product-section" className="py-24 px-4 bg-[#080808] overflow-hidden" data-id="element-173">
      <div className="max-w-5xl mx-auto text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-175">
          <span className="text-gamer-red font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-176">
            Presentando
          </span>
          <h2 className="text-4xl md:text-6xl font-orbitron font-black text-white mb-6" data-id="element-177">
            DOMINIO TOTAL EN{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gamer-red to-orange-500" data-id="element-178">
              FREE FIRE
            </span>
          </h2>

          <div className="max-w-2xl mx-auto space-y-4 text-lg text-gray-300 font-inter" data-id="element-179">
            <p data-id="element-180">
              Un sistema paso a paso diseñado para darte ventaja real sobre la
              mayoría de los jugadores.
            </p>
            <p className="font-bold text-white" data-id="element-181">No son tips sueltos.</p>
            <p data-id="element-182">Es un método estructurado de mejora en 7 días.</p>
          </div>
        </motion.div>

        {/* Digital Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        rotateX: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        rotateX: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        type: 'spring'
      }} className="relative mx-auto w-72 md:w-96 lg:w-[420px]" data-id="element-183">
          {/* Glow behind */}
          <div className="absolute inset-4 bg-gamer-red blur-[80px] opacity-30 animate-pulse-slow" data-id="element-184"></div>

          {/* Product Image */}
          <img src="https://cdn.magicpatterns.com/uploads/c5Tv7jfJPnhHqxw3Uz5vfm/WhatsApp_Image_2026-02-12_at_9.10.25_AM.jpg" alt="Dominio Total en Free Fire - Ebook digital" className="relative z-10 w-full h-auto drop-shadow-[0_20px_50px_rgba(255,26,26,0.3)]" data-id="element-185" />
        </motion.div>

        {/* Pricing */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 flex flex-col items-center gap-2" data-id="element-186">
          <div className="inline-flex items-center gap-2 bg-gamer-red/10 border border-gamer-red/30 rounded-full px-4 py-1 mb-2" data-id="element-187">
            <span className="text-gamer-yellow text-xs font-bold tracking-widest uppercase" data-id="element-188">
              🔥 Oferta por tiempo limitado
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-189">
            <span className="text-gray-500 line-through text-2xl md:text-3xl font-inter" data-id="element-190">
              $27 USD
            </span>
            <span className="text-white font-orbitron font-black text-5xl md:text-6xl" data-id="element-191">
              $9{' '}
              <span className="text-2xl md:text-3xl text-gray-400 font-inter font-normal" data-id="element-192">
                USD
              </span>
            </span>
          </div>
          <p className="text-gamer-red font-bold text-lg font-inter mt-1" data-id="element-193">
            Ahorrás $18 USD — 67% OFF
          </p>

          {/* Buy Button */}
          <div className="mt-8 w-full md:w-auto" data-id="element-194">
            <GamerButton fullWidth href="https://juegospro369.online/cart/52665779487087:1" className="md:w-auto md:px-12 text-xl md:text-2xl py-6 shadow-[0_0_30px_rgba(255,26,26,0.4)]" data-id="element-195">
              ACCEDER AHORA Y EMPEZAR A GANAR
            </GamerButton>
          </div>
        </motion.div>
      </div>
    </section>;
}